import type { InventoryRow } from '../types/inventoryRow';
import type { MockLineValidationEntry } from '../utils/inventoryLineValidationStorage';
import type { SupervisorControlEntry } from '../utils/inventorySupervisorControlStorage';

/** Inventaire POC : toutes les lignes sont comptées et contrôlées — il reste à clôturer l’inventaire. */
export const DEMO_INVENTORY_READY_TO_CLOSE_REF = 'INV-2026-006';

const DEMO_INVENTORISTE_EMAIL = 'nicolas.petit@revers.io';
const DEMO_SUPERVISEUR_EMAIL = 'claire.dubois@revers.io';

/** Quantités comptées par ligne (écart volontaire sur quelques références). */
const DEMO_COUNTED_QUANTITIES: readonly number[] = [5, 8, 9, 10, 13, 16, 17, 19];

const buildDemoLineIds = (reference: string): string[] =>
  Array.from({ length: 8 }, (_, index) => `${reference}-L${index + 1}`);

export function isDemoInventoryReadyToClose(reference: string): boolean {
  return reference === DEMO_INVENTORY_READY_TO_CLOSE_REF;
}

export function getDemoInventoryListRow(): InventoryRow {
  const quantiteTheorique = DEMO_COUNTED_QUANTITIES.reduce(
    (sum, _, index) => sum + (5 + index * 2),
    0,
  );
  const quantiteComptee = DEMO_COUNTED_QUANTITIES.reduce((sum, qty) => sum + qty, 0);

  return {
    reference: DEMO_INVENTORY_READY_TO_CLOSE_REF,
    dateCreation: '2026-05-18',
    dateMiseAJour: '2026-05-19',
    site: 'Auchan Neuilly sur marne',
    stock: 'Box de Martin',
    superviseur: 'Claire Dubois',
    inventoriste: 'Nicolas Petit',
    emplacement: 'A3-C2-01',
    nombreArticles: 8,
    quantiteTheorique,
    quantiteComptee,
    sommePaHt: 412.5,
    sommePvTtc: 728.4,
    ecart: quantiteComptee - quantiteTheorique,
    statut: 'En cours',
    dateComptage: '',
  };
}

export function getDemoLineValidations(
  referenceInventaire: string,
): Record<string, MockLineValidationEntry> | undefined {
  if (!isDemoInventoryReadyToClose(referenceInventaire)) {
    return undefined;
  }

  const lineIds = buildDemoLineIds(referenceInventaire);

  return Object.fromEntries(
    lineIds.map((lineId, index) => [
      lineId,
      {
        quantiteComptee: String(DEMO_COUNTED_QUANTITIES[index]),
        comptePar: DEMO_INVENTORISTE_EMAIL,
      },
    ]),
  );
}

export function getDemoSupervisorControls(
  referenceInventaire: string,
): Record<string, SupervisorControlEntry> | undefined {
  if (!isDemoInventoryReadyToClose(referenceInventaire)) {
    return undefined;
  }

  const lineIds = buildDemoLineIds(referenceInventaire);

  return Object.fromEntries(
    lineIds.map((lineId) => [lineId, { controlePar: DEMO_SUPERVISEUR_EMAIL }]),
  );
}
